"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InspirationOrgContextConsumer = exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var defaults = {
  selectedInspirationOrgId: '',
  setSelectedOrgId: function setSelectedOrgId() {},
  organisationMemberships: []
};

var inspirationOrgContext = _react.default.createContext(defaults);

var _default = inspirationOrgContext;
exports.default = _default;
var InspirationOrgContextConsumer = inspirationOrgContext.Consumer;
exports.InspirationOrgContextConsumer = InspirationOrgContextConsumer;